(function () {

    'use strict';

    angular.module('app.common', []);

})();


// WEBPACK FOOTER //
// ./app/common/common.module.js